import { render, staticRenderFns } from "./add-new-user.html?vue&type=template&id=0745b939&scoped=true&"
import script from "./add-new-user.js?vue&type=script&lang=js&"
export * from "./add-new-user.js?vue&type=script&lang=js&"
import style0 from "./add-new-user.scss?vue&type=style&index=0&id=0745b939&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745b939",
  null
  
)

export default component.exports